import { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { MarkerF } from '@react-google-maps/api';

class Clusters extends Component {
  render() {
    const { clusters, map } = this.props;

    if (_.isNil(clusters)) {
      return null;
    }

    const clusterOnClick = (centerPoint) => {
      if (map) {
        map.setCenter(centerPoint);
        map.setZoom(map.getZoom() + 1);
      }
    };

    return clusters.map((cluster, i) => {
      // We convert the ItemsCount to a string for the label
      const labelText = cluster.ItemsCount ? cluster.ItemsCount.toString() : '';

      return (
        <MarkerF
          key={`${cluster.Centroid.Latitude}.${cluster.Centroid.Longitude}`}
          position={{
            lat: cluster.Centroid.Latitude,
            lng: cluster.Centroid.Longitude,
          }}
          label={{
            text: labelText,
            color: 'white',
            fontSize: '14px',
            fontWeight: 'bold',
          }}
          icon={{
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 18,
            fillColor: '#00AD08',
            fillOpacity: 1,
            strokeColor: 'white',
            strokeWeight: 2,
          }}
          onClick={() => {
            clusterOnClick({
              lat: cluster.Centroid.Latitude,
              lng: cluster.Centroid.Longitude,
            });
          }}
        />
      );
    });
  }
}

const mapStateToProps = (state) => ({
  clusters: state.status.cluster,
});

export default connect(mapStateToProps)(Clusters);
